import {
  ADVISOR_DRAWDOWN_NOTE_RECEIVED,
  ADVISOR_DRAWDOWN_RECEIVED,
  ADVISOR_DRAWDOWN_SETTINGS_RECEIVED,
  ADVISOR_DRAWDOWN_UNLOADED
} from './types'

export default function drawdown(state = {}, action = {}){
  switch (action.type) {     
    case ADVISOR_DRAWDOWN_NOTE_RECEIVED:
      return {
        ...state,
        note: action.note
      }     
    case ADVISOR_DRAWDOWN_RECEIVED:
      return {
        ...state,
        ...action.data
      }    
    case ADVISOR_DRAWDOWN_SETTINGS_RECEIVED:
      return {
        ...state,
        settings: action.settings
      }
    case ADVISOR_DRAWDOWN_UNLOADED:
        return []
    default:
      return state;
  }
}